import {get} from 'lodash-es';
import React from 'react';
import {Link} from 'react-router-dom';

import {IFieldMeta} from 'entities/metadata';

export interface IRequestLinkProps {
    field: IFieldMeta;
    record: any;
    url: string;
    entityName: string;
    cellClassName?: string;
}

export const RequestLink = ({
    field, record, cellClassName, url,
}: IRequestLinkProps) => {
    const {id} = record;
    const reportUrl = `${url}/${id}`;
    return (
        <div
            style={{color: field?.customColor || ''}}
            className={cellClassName}
        >
            <Link
                to={reportUrl}
            >
                {get(record, field.key)}
            </Link>
        </div>
    );
};
